import http from './http.service';

class RoleService {
    constructor() {
        if (RoleService.instance) {
            return RoleService.instance;
        }

        RoleService.instance = this;
    }

    permissions() {
        return http.get('/role/permissions').then(res => res.data);
    }
    roles() {
        return http.get('/role').then(res => res.data);
    }
    store(data) {
        return http.post('/role/store', data).then(res => res.data);
    }
    update(roleId, data) {
        return http.put(`/role/${roleId}/update`, data).then(res => res.data);
    }
    updatePermissions(roleId, data) {
        return http.put(`/role/${roleId}/update-permissions`, data).then(res => res.data);
    }
    destroy(roleId) {
        return http.delete(`/role/${roleId}/destroy`).then(res => res.data);
    }
}

export default new RoleService();
